<div class="container-fluid">
  <div class="form-step three-stup">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div> -->
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pagar</span>
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Certificado</span>
      </div> -->
    </div>
  
  </div>
  <span class="letter-style-normal adjust-text-right font-weight-bolder text-center d-block pt-3">En solo tres pasos podrás cotizar tu seguro. ¡Empecemos!</span>
   
  <div class="form-section stups-2">
    <div class="form-left-section form-itams">
      <img [attr.alt]="ballPink1srcNew" [attr.src]="ballPink1srcNew" class="img-fluid style-img-basketball" />
    </div>
    <form [formGroup]="stepTwoForm" class="p-5 pt-4 pb-4 form-general-style label-text-center mobile-form-padding">
      <div class="mb-16px form-group">
        <label for="birthDates" class="mb-3 label-form-style d-flex">Fecha de Nacimiento del aplicante *</label>
        <div class="row stup-2 formControlRow">
          <div class="col dateFormControlContainer">
            <app-input-field 
            [formGroup]="stepTwoForm" 
            controlName="selectedDay" 
            id="selectedDay" 
            (inputChange)="allowOnlyNumbers($event)"
            label="Día"
            errorMessage="Día requerido"
            minMaxErrorMessage="Valor incorrecto"
            [submitted]="submitted"
            [hasError]="hasBirthdateError"
            class="grey-text-input"
            ></app-input-field>
            
          </div>
         
          <!-- <div class="col form-group">
            
            <input type="text" class="form-control form-input input-form-full-space" formControlName="selectedDay" id="selectedDay" (input)="allowOnlyNumbers($event)" onkeyup="this.setAttribute('value', this.value);" value="{{stepTwoForm.controls['selectedDay'].value}}">
              <label for="selectedDay" class="form-input-label">Día *</label>
            <div class="text-danger" *ngIf="submitted && stepTwoForm.controls['selectedDay'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Día requerido
              </label>
            </div>
            <div class="text-danger"
              *ngIf="submitted && (stepTwoForm.controls['selectedDay'].errors?.min || stepTwoForm.controls['selectedDay'].errors?.max)">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Valor incorrecto
              </label>
            </div>
          </div> -->
          <div class="col dateFormControlContainer">
            <app-input-field 
            [formGroup]="stepTwoForm" 
            controlName="monthSelected" 
            id="monthDay" 
            (inputChange)="allowOnlyNumbers($event)"
            label="Mes"
            errorMessage="Mes requerido"
            minMaxErrorMessage="Valor incorrecto"
            [submitted]="submitted"
            [hasError]="hasBirthdateError"
            class="grey-text-input"
            ></app-input-field>
            
          </div>
          <!-- <div class="col form-group">
            
            <input type="text" class="form-control form-input input-form-full-space" formControlName="monthSelected" id="monthDay" (input)="allowOnlyNumbers($event)" onkeyup="this.setAttribute('value', this.value);" value="{{stepTwoForm.controls['monthSelected'].value}}">
              <label for="monthDay" class="form-input-label">Mes *</label>
            <div class="text-danger" *ngIf="submitted && stepTwoForm.controls['monthSelected'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Mes requerido
              </label>
            </div>
            <div class="text-danger"
              *ngIf="submitted && (stepTwoForm.controls['monthSelected'].errors?.min || stepTwoForm.controls['monthSelected'].errors?.max)">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Valor incorrecto
              </label>
            </div>
          </div> -->
          <div class="col dateFormControlContainer">
            <app-input-field 
            [formGroup]="stepTwoForm" 
            controlName="yearSelected" 
            id="yearDay" 
            (inputChange)="allowOnlyNumbers($event)"
            label="Año"
            errorMessage="Año requerido"
            minMaxErrorMessage="Valor incorrecto"
            [submitted]="submitted"
            [hasError]="hasBirthdateError"
            class="grey-text-input"
            ></app-input-field>
            
          </div>
          <!-- <div class="col form-group">            
            <input type="text" class="form-control form-input xxinput-form-full-space" formControlName="yearSelected" id="yearDay" (input)="allowOnlyNumbers($event)" onkeyup="this.setAttribute('value', this.value);" value="{{stepTwoForm.controls['yearSelected'].value}}">
              <label for="yearDay" class="form-input-label">Año *</label>
            <div class="text-danger" *ngIf="submitted && stepTwoForm.controls['yearSelected'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Año requerido
              </label>
            </div>
            <div class="text-danger"
              *ngIf="submitted && (stepTwoForm.controls['yearSelected'].errors?.min || stepTwoForm.controls['yearSelected'].errors?.max)">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Valor incorrecto
              </label>
            </div>
          </div> -->
        </div>  
        <label *ngIf="ageErrorMessage" class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;"><img src="/assets/external/warnning-vector.svg" class="img-fluid pr-1">84 años edad máxima</label>
      </div>
  
      <div class="form-group mb-16px py-2" [class.dep-nudge]="nudgeDependents">
        <div class="d-flex align-items-center">
          <div class="pr-3 w-50px">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="red" class="img-cursor-pointer"
              xmlns="http://www.w3.org/2000/svg" (click)="addDependencies()">
              <path
                d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z"
                fill="#2828E0" />
            </svg>
          </div>
          <span class="text-style-blue text-center pr-3 w-50px" style="line-height:27px;">
            <span>{{dependencies}}</span>
          </span>
            <div class="pr-3">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="img-cursor-pointer"
                xmlns="http://www.w3.org/2000/svg" (click)="lessDependencies()">
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H5V9H15V11Z"
                  fill="#E6E8EB" />
              </svg>
            </div>            
            <div class="pl-2">
              <span class="text-style-blue">
                <span>Añadir dependiente</span>
              </span>
            </div>          
        </div>
      </div>
      <div class="form-group mb-16px">
        <div class="px-4 background-effect over65-box" [class.is-fill]="dependencies > 0">
          <div class="d-flex" style="justify-content: space-between;">
            <span>¿Algún dependiente mayor a 65?</span>
            <p-inputSwitch formControlName="checked" />
          </div>
        </div>
      </div>
      <div class="form-group mb-16px py-2" *ngIf="stepTwoForm.controls['checked'].value">
        <div class="row">
          <div class="pl-3 d-flex">
            <div class="pr-4 w-50px">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="img-cursor-pointer"
                xmlns="http://www.w3.org/2000/svg" (click)="addDependenciesOlder()">
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z"
                  fill="#2828E0" />
              </svg>
            </div>
            <span class="text-style-blue text-center pr-3 w-50px" style="line-height:27px;">
              <span>{{dependenciesOlder}}</span>
            </span>
            
            <div class="pr-3">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="img-cursor-pointer"
                xmlns="http://www.w3.org/2000/svg" (click)="lessDependenciesOlder()">
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H5V9H15V11Z"
                  fill="#E6E8EB" />
              </svg>
            </div>
            
            <div class="pl-2">
              <span class="text-style-blue">
                <span>Dependientes mayores de 65</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group mb-0"><button type="submit" (click)="nextStep()" class="btn btn-primary continue-btn-steps py-3">Continuar</button></div>
      
     
    </form>
    <div class="form-right-section form-itams">
      <img [attr.alt]="towerNew" [attr.src]="towerNew" class="img-fluid style-img-tower" />
    </div>
    <a href="javascript:void(0)" class="back-link" (click)="prevStep()">
      < Atrás</a>
    <div class="copy-right">
      <p>All rights reserved by BAC Financial Services. | Política de privacidad | Design by <a href="https://www.wemarkforyou.com" target="_blank">www.wemarkforyou.com</a>. </p>
      <h5>Politica de privacidad</h5>
    </div>
  </div>
   
</div>